export const features = {
  verification: false,
  purposes: ["activate", "verify", "reset-password", "deleteuseraccess"],
};
